// se asegura de que todos frameworks que requiera la aplicación estén disponibles y lanza la aplicación
// requiere jQuery precargado
(function () {
    "use strict";
    var jqueryReady = $.Deferred();
    $(document).ready(function () {
        jqueryReady.resolve();
    });
    var _initVistasImp = function (vistas, vistaIdx, def) {
        if (vistas.length > vistaIdx) {
            ç.core.loadCachedScript(ç.core.getUrlRoot().trimEnd('/') + '/SPA/paginas/' + vistas[vistaIdx].name + '/' + vistas[vistaIdx].name + ç.core.getScrType() + '.js?_=' + ç.app.version).done(function () {
                $.each(vistas[vistaIdx].rutas, function (idEl, el) {
                    page(el.path, window[vistas[vistaIdx].name][el.methodName]);
                });
                _initVistasImp(vistas, vistaIdx + 1, def);
            }).fail(function () {
                def.reject();
            });
        } else {
            def.resolve();
        }
    };
    var _initVistas = function (vistas) {
        return $.Deferred(function (def) {
            _initVistasImp(vistas, 0, def);
        });
    };
    var _initElementsImp = function (relativePath, elements, elementIdx, def) {
        if (elements.length > elementIdx) {
            ç.core.loadCachedScript(ç.core.getUrlRoot().trimEnd('/') + relativePath + elements[elementIdx] + '/' + elements[elementIdx] + ç.core.getScrType() + '.js?_=' + ç.app.version).done(function () {
                _initElementsImp(relativePath, elements, elementIdx + 1, def);
            }).fail(function () {
                def.reject();
            });
        } else {
            def.resolve();
        }
    };
    var _initElements = function (relativePath, elements) {
        return $.Deferred(function (def) {
            _initElementsImp(relativePath, elements, 0, def);
        });
    };
    var _processCustomAction = function (customAction) {
        return $.Deferred(function (def) {
            if (typeof customAction !== typeof undefined && customAction !== null &&
                typeof customAction.actionName !== typeof undefined && customAction.actionName !== null && !customAction.actionName.toString().isNullOrWhitespace() &&
                typeof customAction.actionData !== typeof undefined && customAction.actionData !== null && !customAction.actionData.toString().isNullOrWhitespace()) {
                if (customAction.actionName === 'createlogin') {
                    altaUsuario.execute({ codigoCliente: customAction.actionData }).always(function () {
                        def.resolve(true);
                        //Tras realizar la acción, redirigimos a la página de usuarios
                        ç.core.simularClick(usuarios.getPageRoute());
                    });
                } else {
                    def.resolve(false);
                }
            } else {
                def.resolve(false);
            }
        });
    };
    function _kickstart() {
        //Aplicamos las inicializaciones de las librerías. Iniciamos la carga de scripts versionados, si actualizamos versión, se cargan las nuevas versiones. El sufijo ?_1.2.3.4 no altera la localización del recurso.
        ç.core.loadCachedScripts([
            ç.core.getUrlRoot().trimEnd('/') + '/SPA/scripts/frameworksInit' + ç.core.getScrType() + '.js?_=' + ç.app.version,
            ç.core.getUrlRoot().trimEnd('/') + '/SPA/scripts/globalEvents' + ç.core.getScrType() + '.js?_=' + ç.app.version,
            ç.core.getUrlRoot().trimEnd('/') + '/SPA/controladores/sincronizador' + ç.core.getScrType() + '.js?_=' + ç.app.version,
            ç.core.getUrlRoot().trimEnd('/') + '/SPA/controladores/comun' + ç.core.getScrType() + '.js?_=' + ç.app.version,
            ç.core.getUrlRoot().trimEnd('/') + '/SPA/controladores/carrito' + ç.core.getScrType() + '.js?_=' + ç.app.version,
            ç.core.getUrlRoot().trimEnd('/') + '/SPA/controladores/sesion' + ç.core.getScrType() + '.js?_=' + ç.app.version,
            ç.core.getUrlRoot().trimEnd('/') + '/SPA/controladores/cliente' + ç.core.getScrType() + '.js?_=' + ç.app.version,
            ç.core.getUrlRoot().trimEnd('/') + '/SPA/controladores/userConfig' + ç.core.getScrType() + '.js?_=' + ç.app.version
        ]).done(function () {
            sesion.init().done(function () {
                ç.login.checkLogueado().done(function () {
                    sincronizador.init().done(function () {
                        sesion.initControls().done(function () {
                            userConfig.init().done(function () {
                                //TODO: Estudiar si se usa en versión+localStorage
                                var pathPrefix = ç.core.getPathPrefix();
                                var vistas = [{ name: 'inicio', rutas: [{ path: pathPrefix + '/', methodName: 'show' }] },
                                {
                                    name: 'busqueda', rutas: [
                                      { path: pathPrefix + '/busqueda', methodName: 'show' },
                                      { path: pathPrefix + '/busqueda/:soloConsumidos/:articulosFltr/:familiasFltr', methodName: 'show' },
                                      //{ path: pathPrefix + '/busqueda/addFamiliaFilter/:addFamiliaFilter', methodName: 'addFamiliaFilter' },
                                      { path: pathPrefix + '/busqueda/setFamiliaFilter/:setFamiliaFilter', methodName: 'setFamiliaFilter' },
                                      { path: pathPrefix + '/busqueda/setConsumidosFilter/:setConsumidosFilter', methodName: 'setConsumidosFilter' }
                                    ]
                                },
                                { name: 'creditos', rutas: [{ path: pathPrefix + '/creditos', methodName: 'show' }] },
                                { name: 'termcond', rutas: [{ path: pathPrefix + '/termcond', methodName: 'show' }] },
                                { name: 'polpriv', rutas: [{ path: pathPrefix + '/polpriv', methodName: 'show' }] },
                                { name: 'usuarios', rutas: [{ path: pathPrefix + '/usuarios', methodName: 'show' }] },
                                { name: 'producto', rutas: [{ path: pathPrefix + '/producto/:codigoArticulo', methodName: 'show' }] },
                                { name: 'cartCheckout', rutas: [{ path: pathPrefix + '/carrito/revisar', methodName: 'show' }] },
                                { name: 'facturas', rutas: [{ path: pathPrefix + '/facturas', methodName: 'show' }] },
                                { name: 'pedido', rutas: [{ path: pathPrefix + '/pedido/:codigoPedido', methodName: 'show' }] },
                                { name: 'estadoPedido', rutas: [{ path: pathPrefix + '/estadoPedido/:codigoPedido', methodName: 'show' }] },
                                { name: 'pedidos', rutas: [{ path: pathPrefix + '/pedidos', methodName: 'show' }] },
                                { name: 'configuracion', rutas: [{ path: pathPrefix + '/configuracion', methodName: 'show' }] }];
                                if (VerCatalogo === true || VerCatalogo === 'true') {
                                    vistas.push({ name: 'catalogo', rutas: [{ path: pathPrefix + '/catalogo', methodName: 'show' }] });
                                }
                                _initVistas(vistas).done(function () {
                                    _initElements('/SPA/dialogos/', ['altaUsuario', 'addItem', 'selectLocal']).done(function () {
                                        comun.init().done(function () {
                                            cliente.init().done(function () {
                                                carrito.init().done(function () {
                                                    var customAction = ç.core.popCustomAction();
                                                    _processCustomAction(customAction).done(function (resCA) {
                                                        if (resCA !== true) {
                                                            page();
                                                        }
                                                    });
                                                }).fail(function (error) {
                                                    ç.showError(error);
                                                });
                                            }).fail(function (error) {
                                                ç.showError(error);
                                            });
                                        }).fail(function () {
                                            ç.showError('error cargando');
                                        });
                                    }).fail(function () {
                                        ç.showError('error cargando');
                                    });
                                }).fail(function () {
                                    ç.showError('error cargando');
                                });
                            }).fail(function (error) {
                                ç.showError(error);
                            });
                        }).fail(function (error) {
                            ç.showError(error);
                        });
                    }).fail(function (error) {
                        ç.showError(error);
                    });

                }).fail(function (error) {
                    //no tenemos sesión, habrá que esperar a que el usuario inicie sessión correctamente
                });
            }).fail(function (error) {
                ç.showError(error);
            });
        }).fail(function () {
            ç.showError(ç.lang.list[ç.lang.current].omniaShop.errorInesperado);
        });
    }
    $.when(jqueryReady).then(function () {
        _kickstart();
    });
})();